import React from 'react';
import { FormattedMessage } from 'react-intl';
import { array } from 'prop-types';
import FaqTreeList from './FaqTreeList';

const propTypes = {
  tree: array.isRequired,
};

const defaultProps = {
  tree: [],
};

const FaqHeaderList = ({ tree, closeModal }) =>
  tree.length > 0 ? (
    <dl className="faq-tree-list">
      {tree.map(
        (item) =>
          item.children.length > 0 && (
            <div key={item.id} className="faq-tree-list-section">
              <FaqTreeList pages={Object.values(item.children)} closeModal={closeModal} />
            </div>
          ),
      )}
    </dl>
  ) : (
    <div className="card-empty">
      <FormattedMessage id="faq.no-content" defaultMessage="No Content" />
    </div>
  );

FaqHeaderList.propTypes = propTypes;
FaqHeaderList.defaultProps = defaultProps;

export default FaqHeaderList;
